import { useNavigate, useParams } from "react-router-dom";
import { useCallback, useEffect } from "react";
import { AdvancedAnalyticsVehicles } from "../../home/fleet/fleetApi";
import { AdvancedAnalyticsVehicleSidePanel } from "../../home/fleet/advancedAnalytics/AdvancedAnalyticsVehiclesSidePanel";
import { SharedInterfaceAnalyticsVehiclesTab } from "../../home/fleet/advancedAnalytics/sharedInterface";
import {
  driversHistoryByDepartmentAsync,
  selectDriversHistoryListStatus,
} from "../../home/fleet/fleetSlice";
import { useAppDispatch, useAppSelector } from "../../../redux/hooks";
import { selectCurrentDepartment } from "../departments/departmentsSlice";

export const AdvancedAnalyticsVehiclesTab = () => {
  const params = useParams();
  const navigate = useNavigate();
  const firstPath = location.pathname.split("/")[1]; 
  const dispatch = useAppDispatch();
  const department = useAppSelector(selectCurrentDepartment);
  const driversHistoryListStatus = useAppSelector(
    selectDriversHistoryListStatus,
  );
  const sidePanelAction = useCallback(
    (props: Partial<AdvancedAnalyticsVehicles>) => {
      navigate(`/${firstPath}/fleet/advanced_analytics/${props.uuid}`);
    },
    [navigate, firstPath],
  );

  useEffect(() => {
    if (department && driversHistoryListStatus === "idle") {
      void dispatch(driversHistoryByDepartmentAsync(department.uuid));
    }
  }, [dispatch, department, driversHistoryListStatus]);

  if (params.tab !== "advanced_analytics") {
    return;
  }

  return (
    <SharedInterfaceAnalyticsVehiclesTab
      sidePanelAction={sidePanelAction}
      sidePanel={<AdvancedAnalyticsVehicleSidePanel />}
    />
  );
};
